export default "__VITE_ASSET__DU6jAWX7__"